import styled from "styled-components"

export const Container = styled.div`
	width: 100%;
	height: 80px;
	padding: ${({ hasReturnIcon }) => hasReturnIcon ? "20px 0 20px 0" : "20px 0 20px 20px"};

	display: flex;
	justify-content: space-between;
	align-items: center;

	background-color: #F8FAFD;

	border-bottom: solid 1px #E3E3E3;
`

export const CustomerClientInfo = styled.div`
	display: flex;

	align-items: center;
`

export const LogoContainer = styled.div`
	width: auto;
	margin-right: auto;
`

export const Logo = styled.img`
	width: auto;
  height: auto;

  object-fit: contain;

	max-width: 80%;
	max-height: 38px;
`

export const LogoInvisiblePlaceholder = styled.div`
	height: 100%;
	width: auto;
	max-width: 80%;
	margin-right: auto;
`